import { Component } from '@angular/core';
import { EmemberComponent } from '../../modules/emember/emember.component';

@Component({
  selector: 'ava-root',
  standalone: true,
  template: ` <ava-emember /> `,
  imports: [EmemberComponent],
})
export class AppComponent {}
